import React, { Fragment, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "semantic-ui-react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { GlobalContext } from "../../context/GlobalState";
import { GetMap } from "./components/getMap";
import { AppBar } from "../appBar";
import OBLLogo from "../resources/logo_obl.png";
import Loader from "../Loader";
import { Col } from "reactstrap";

export const Shipment = () => {
  const { resultList, ResultsList, DespliegueDescarga, Results } = useContext(GlobalContext);
  const [downloadDocPDF, setDownloadDocPDF] = useState(false);

  const convertPdf = async () => {
    var svgElements = document.querySelectorAll("svg");

    svgElements.forEach(function (item) {
      item.setAttribute("width", item.getBoundingClientRect().width);
      item.setAttribute("height", item.getBoundingClientRect().height);
      item.style.width = null;
      item.style.height = null;
    });

    setTimeout(function () {
      const input = document.getElementById("EmbarqueDetail_MAP");
      const eventData = document.getElementById("LISTA_DE_EVENTOS");

      const divHeight = input.clientHeight;
      const divWidth = input.clientWidth;
      const ratio = divHeight / divWidth;

      html2canvas(input, {
        useCORS: true,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");

          const width = pdf.internal.pageSize.getWidth();
          let height = pdf.internal.pageSize.getHeight();
          height = ratio * width;

          pdf.addImage(OBLLogo, "JPEG", 8.3, 5, 45, 9);
          pdf.addImage(imgData, "JPEG", 8.3, 20, width - 20, height - 15);

          html2canvas(eventData, { useCORS: true }).then(
            (canvas) => {
              const imgEventos = canvas.toDataURL("image/png");
              pdf.addPage();
              pdf.addImage(OBLLogo, "JPEG", 8.3, 5, 45, 9);
              pdf.addImage(imgEventos, "JPEG", 8.3, 25, width - 20, 100);
              pdf.save(`${resultList[0].ShipmentNumber}.pdf`);
              DespliegueDescarga(false);
              setDownloadDocPDF(false);
            }
          );
        })
        .catch((e) => {
          setDownloadDocPDF(false);
          console.log("ERROR EN DESCARGA", e);
        });
    }, 400);
  };

  const donwloadDoc = async () => {
    setDownloadDocPDF(true);
    await DespliegueDescarga(true);

    convertPdf();
  };

  return (
    <Fragment>
      <Loader hidden={!downloadDocPDF} />
      <div>
        <AppBar />
        <Col xs={8} className='mr-auto ml-auto row mt-5 d-flex align-items-center'>
          <div className="col-4">
            <img
              src={OBLLogo}
              alt="OBL Log"
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-4">
            <Breadcrumb style={{ backgroundColor: "white" }}>
              <Breadcrumb.Section>
              </Breadcrumb.Section>
              {/* <Breadcrumb.Divider icon="right chevron" /> */}
              <Breadcrumb.Section>
                <Link
                  onClick={() => {
                    Results(false);
                    ResultsList([{ ShipmentNumber: null, TransportMode: null, Status: null, UpdateDate: null }]);
                  }}
                  to={"/"}
                >
                  <span className="linkCard" style={{ fontSize: '14px' }}>Back</span>
                </Link>
              </Breadcrumb.Section>
              <Breadcrumb.Divider icon="right chevron" />
              <Breadcrumb.Section active>
                <span className="tag-custom-value-title">
                  {resultList.length !== 0 ? resultList[0].ShipmentNumber : '----'}
                </span>
              </Breadcrumb.Section>
            </Breadcrumb>
          </div>
        </Col>
        <div className="col-8 mr-auto ml-auto">
          <hr className="hr-style mt-2 mb-3" />
        </div>
        <i style={{ color: '#0060a8' }}>
          <div className="col-8 mr-auto ml-auto d-flex justify-content-end mt-3" title="Download PDF">
            <svg width="1.6em" height="1.6em" viewBox="0 0 16 16" class="bi bi-download" fill="currentColor" xmlns="http://www.w3.org/2000/svg" onClick={donwloadDoc} style={{ cursor: 'pointer' }}>
              <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </div>
        </i>

        <Col xs={8} className='mr-auto ml-auto'>
          <div id="divIdToPrint">
            <GetMap />
          </div>
        </Col>
        <div style={{ height: 40 }}></div>
      </div>
    </Fragment >
  );
};
